import React from 'react';

/**
 * Componente de checkbox para filtrar operadores com `nonAdherentTime > 0`.
 *
 * @param {object} props
 * @param {boolean} props.hasNonAdherent – se true, deve exibir apenas registros com tempo inaderente > 0
 * @param {(value: boolean) => void} props.setHasNonAdherent – atualiza o estado `hasNonAdherent` no componente pai
 */
export const InadherenceCheckbox = ({ hasNonAdherent, setHasNonAdherent }) => {
  return (
    <label
      className="form-control-label mb-0"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        whiteSpace: 'nowrap'
      }}
    >
      <input
          type="checkbox"
          id="hasNonAdherent"
          checked={hasNonAdherent}
          onChange={(e) => {
            setHasNonAdherent(e.target.checked);
          }}
          style={{ margin: 0, flexShrink: 0, position: 'static' }}
        />
      <span>Inaderência</span>
    </label>
  );
};
